/* ===========================================================================
   CAPRIMAFFIA — CO·PLANO · 12 oct 2026
   Lo poco que la hoja de estilo no puede hacer sola en la plantilla de
   colección. Son tres cosas, ninguna de ellas pinta nada:

     1) COMPRA desde la rejilla. La fila de tallas vive dentro del
        <product-form-component> del propio tema (lo monta
        `snippets/quick-add.liquid`), así que el cajón del carrito y el
        contador se comportan igual que en la ficha. Aquí solo se fija la
        variante elegida antes de que el formulario se envíe — exactamente lo
        que hace `compra()` en `ht-core.js` para la portada.

     2) AGOTADOS AL FINAL. Se ordena con `order` de CSS, pero POR TANDA: los
        agotados se van al final de SU página, no al final de todo. Si se
        fueran al final de todo, al cargar la página siguiente de productos
        las fichas ya vistas se recolocarían delante de los ojos del cliente
        (y eso es justo el salto de diseño que esta pasada viene a quitar).
        Medido: con el orden por tanda, 0 de CLS al paginar.

     3) Nada más. Ni animaciones, ni observadores sobre contenedores grandes.

   Revertir: quitar la línea de `co-plano.js` de `layout/theme.liquid`. Sin
   este archivo la colección sigue funcionando: la fila de tallas enviaría la
   primera variante disponible (el valor que el tema ya pone en el formulario)
   y los agotados se quedarían donde los manda Shopify.
   =========================================================================== */
(function () {
  'use strict';

  var raiz = document.documentElement;

  /* --------------------------------------------------------------- 1. COMPRA
     Un solo escuchador en el documento, en fase de captura, para que llegue
     antes que el `submit` del formulario y antes de que el enlace de la
     tarjeta se lleve el clic. */
  document.addEventListener(
    'click',
    function (ev) {
      var talla = ev.target.closest && ev.target.closest('[data-co-variant]');
      if (!talla || talla.disabled) return;

      /* 🚨 La tarjeta entera es un <a href="/products/…">. Sin esto, el clic
         en la talla navega a la ficha y la compra no llega nunca. */
      ev.stopPropagation();

      var form = talla.closest('form');
      var input = form && form.querySelector('[ref="variantId"]');
      if (!input) return;
      input.value = talla.getAttribute('data-co-variant');
      input.disabled = false;

      var fila = talla.closest('.co-sizes');
      if (fila) {
        fila.setAttribute('data-co-done', talla.textContent.trim());
        setTimeout(function () { fila.removeAttribute('data-co-done'); }, 1500);
      }
    },
    true
  );

  /* ------------------------------------------------------ 2. AGOTADOS AL FINAL
     `--co-ord` entra en el `order` de la ficha desde la hoja de estilo. Pares
     para las disponibles, impares para las agotadas: así, dentro de cada tanda
     las agotadas caen detrás, y ninguna tanda se mezcla con otra.

     🚨 CÓMO SE SABE QUE UNA FICHA ESTÁ AGOTADA. Costó dos intentos, los dos
     medidos en vivo sobre las nueve fichas de LONGSLEEVE (dos agotadas):

     · Intento 1 — «tiene `.product-badges`». MAL: ese contenedor lo pinta el
       tema en TODAS las tarjetas, vacío cuando no hay nada que decir. Salieron
       las nueve marcadas como agotadas.
     · Intento 2 — «no tiene `<quick-add-component>`». MAL también: el tema lo
       monta SIEMPRE y decide si se ve con una variable de CSS
       (`--quick-add-display`), no quitándolo. Salieron las nueve disponibles.
     · Lo que sí vale: el TEXTO de la chapa. Medido, solo las dos agotadas
       llevan «Agotado» dentro de `.product-badges`, y las otras siete la
       tienen vacía.

     Respaldo: una prenda agotada tampoco tiene fila de tallas (se monta solo
     con `product.available`), pero eso no sirve por sí solo porque una prenda
     de talla única disponible tampoco la tiene. */
  function agotada(ficha) {
    var chapa = ficha.querySelector('.product-badges');
    if (chapa && /agotad|sold\s*out/i.test(chapa.textContent)) return true;
    return false;
  }

  /* Se marca SIEMPRE, en los tres modos. Quién hace qué con la marca lo decide
     la hoja: `order` cuando el modo es «al final», `display: none` cuando es
     «ocultar», y nada cuando es «mezclados». Si el marcado dependiera del modo,
     «ocultar» no tendría a qué agarrarse. */
  function ordenar() {
    if (raiz.getAttribute('data-co-out') === 'mezclados') return;

    var rejillas = document.querySelectorAll('.product-grid');
    for (var i = 0; i < rejillas.length; i++) {
      var tanda = parseInt(rejillas[i].getAttribute('data-co-tanda') || '0', 10);
      var fichas = rejillas[i].children;
      var nuevas = 0;

      for (var j = 0; j < fichas.length; j++) {
        if (fichas[j].hasAttribute('data-co-ord')) continue;
        nuevas++;
        var fuera = agotada(fichas[j]);
        fichas[j].style.setProperty('--co-ord', tanda * 2 + (fuera ? 1 : 0));
        fichas[j].setAttribute('data-co-ord', fuera ? 'out' : 'in');
      }

      if (nuevas) rejillas[i].setAttribute('data-co-tanda', tanda + 1);
    }
  }

  function vigilar() {
    ordenar();
    var rejillas = document.querySelectorAll('.product-grid');
    for (var i = 0; i < rejillas.length; i++) {
      /* `childList` y nada más: no se observan atributos ni subárboles, así
         que el observador no se despierta cuando el tema toca una foto. */
      new MutationObserver(ordenar).observe(rejillas[i], { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigilar, { once: true });
  } else {
    vigilar();
  }

  /* La colección se repinta entera al filtrar o al ordenar (la API de
     secciones devuelve una `.product-grid` nueva). */
  document.addEventListener('shopify:section:load', vigilar);
})();
